"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("./lib/Utils");
var ViewportMonitor_1 = require("./lib/ViewportMonitor");
var statsApi_1 = require("./lib/statsApi");
var config_1 = require("./config");
var article_1 = require("./article");
var ImpressionProductsViewArticleStats = /** @class */ (function () {
    function ImpressionProductsViewArticleStats(getCookie, setCookie) {
        var _this = this;
        this._newContainer = function (container) {
            var view = container.getAttribute("data-view");
            if (!view) {
                console.warn("Found impression container without [data-view]. Please check your html.");
                return;
            }
            _this._registerView(view);
        };
        this._registerView = function (view) {
            if (_this.Views[view]) {
                console.warn("View [" + view + "] is duplicated. Please check your html");
                return;
            }
            var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, Origin = _a.Origin, Platform = _a.Platform, SearchWord = _a.SearchWord, Integration = _a.Integration, PageType = _a.PageType, SearchType = _a.SearchType, VariantName = _a.VariantName, Provider = _a.Provider;
            var URL_STATS_API = config_1.getConfiguration().URL_STATS_API;
            var apiController = new statsApi_1.default(URL_STATS_API);
            apiController.InitializeProductsViewArticlesImpression({
                PageType: PageType,
                Integration: Integration,
                Platform: Platform,
                Provider: Provider,
                VariantName: VariantName,
                SearchCity: SearchCity,
                SearchType: SearchType,
                SearchWord: SearchWord,
                Origin: Origin,
            });
            _this.Views[view] = apiController;
        };
        this._pushImpression = function (item, container) {
            //@ts-ignore
            var _a = item.dataset, position = _a.position, idcatalog = _a.idcatalog, id = _a.id, brand = _a.brand, product = _a.product, modelname = _a.modelname, filter = _a.filter, _b = _a.itemtype, itemtype = _b === void 0 ? article_1.ArticleType.ARTICLE : _b;
            var Position = parseInt(position);
            var CatalogId = parseInt(idcatalog);
            if (!Utils_1.isNumber(Position) || !Utils_1.isNumber(CatalogId)) {
                if (!item.classList.contains("advertising")) {
                    console.warn("Error processing print element");
                    console.warn(item);
                }
                return;
            }
            //@ts-ignore
            var view = container.dataset.view;
            var apiController = _this.Views[view];
            if (apiController) {
                apiController.PushProductsViewArticle({
                    ItemType: itemtype,
                    ArticleId: id,
                    ProductId: product,
                    CatalogId: idcatalog,
                    BrandId: brand,
                    Position: position,
                    View: view,
                    ModelName: modelname,
                    Filter: filter,
                    getCookie: _this.$getCookie,
                    setCookie: _this.$setCookie,
                });
            }
        };
        this.Views = [];
        this.$getCookie = getCookie;
        this.$setCookie = setCookie;
        this.ViewportMonitor = new ViewportMonitor_1.default({
            containerClass: "js-print-products-view-article-container",
            itemClass: "js-print-products-view-article-item",
            onNewContainer: this._newContainer,
            onNewItem: this._pushImpression,
        });
    }
    return ImpressionProductsViewArticleStats;
}());
exports.default = ImpressionProductsViewArticleStats;
//# sourceMappingURL=products-view-article-impression.js.map